import React from "react";

import type { Integration } from "../types/integrations";

interface UseIntegrationModalStateProps {
  isOpen: boolean;
  integration: Integration | null;
}

export function useIntegrationModalState({
  isOpen,
}: UseIntegrationModalStateProps) {
  const [crawlerPreferenceError, setCrawlerPreferenceError] = React.useState<
    string | null
  >(null);
  const [fromCrawlerPreference, setFromCrawlerPreference] =
    React.useState(false);
  const [selectedAccountId, setSelectedAccountId] = React.useState<
    string | undefined
  >(undefined);
  const [internalIsOpen, setInternalIsOpen] = React.useState(isOpen);
  const [showNonOAuthForm, setShowNonOAuthForm] = React.useState(false);

  // Store OAuth callback state to persist it even after URL cleanup
  const [oauthCallbackState, setOauthCallbackState] = React.useState<{
    isOAuthCallback: boolean;
    success: boolean;
    reason?: string | null;
  } | null>(null);

  const actualIsOpen = isOpen || internalIsOpen;

  const resetState = React.useCallback(() => {
    setFromCrawlerPreference(false);
    setSelectedAccountId(undefined);
    setCrawlerPreferenceError(null);
    setInternalIsOpen(false);
    setShowNonOAuthForm(false);
    setOauthCallbackState(null);
  }, []);

  return {
    // State values
    crawlerPreferenceError,
    fromCrawlerPreference,
    selectedAccountId,
    internalIsOpen,
    actualIsOpen,
    showNonOAuthForm,
    oauthCallbackState,

    // State setters
    setCrawlerPreferenceError,
    setFromCrawlerPreference,
    setSelectedAccountId,
    setInternalIsOpen,
    setShowNonOAuthForm,
    setOauthCallbackState,

    // Helper functions
    resetState,
  };
}
